// =============================================================
// GiftOverlay — pops when the user feeds the Yuzu cat. Mirrors
// the inline #yuzu-gift-overlay div in the original.
// =============================================================

interface GiftOverlayProps {
  open: boolean
  desc: string
  onClose: () => void
}

export function GiftOverlay({ open, desc, onClose }: GiftOverlayProps) {
  return (
    <div
      className={`gift-overlay ${open ? 'open' : ''}`}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose()
      }}
    >
      <div className="gift-box">
        <div className="gift-icon">🎁</div>
        <div className="gift-title">猫猫回赠你一件礼物！</div>
        <div className="gift-desc">{desc}</div>
        <button className="gift-btn" onClick={onClose}>
          抱抱收下 🐾
        </button>
      </div>
    </div>
  )
}